const CasualtyAge = {
    chart: {
        type: 'bar',
        height: 143,
        minWidth: "100%!important",
        marginTop: 28,
        marginBottom: 5,
        marginLeft:80,
        backgroundColor: '#F2F3F3',
        borderRadius: 8,
    },
    exporting: {
        enabled: false
    },
    title: {
        text: "Casualty age",
        align: 'left',
        style: {
            fontFamily: 'Stolzl-Medium',
            fontStyle: 'normal',
            color: '#282B2D',
            textDecoration: 'none',
            fontSize: 14,
            fontWeight: '500',
            lineHeight: 18,
            whiteSpace:'nowrap'
        }
    },

    xAxis: {
        categories: [{name: "0-17", key: '0-17'},
            {name: '18-25', key: '18-25'},
            {name: '26-64', key: '26-64'},
            {name: '65+', key: 'over 65'}],
        gridLineWidth: 0,
        lineWidth: 0,
        labels: {
            y: 5,
            x: -4,
            enabled: true,
            style: {
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '11px',
                textOutline: 'none',
                lineHeight: '16px',
                textAlign: 'center',
                color: '#3D3935'
            },
            formatter: function () {
                return this.value.name
            }
        }
    },
    yAxis: {
        min: 0,
        startOnTick: false,
        gridLineWidth: 0,
        title: {
            enabled: false
        },
        labels: {
            enabled: false,
        }
    },
    plotOptions: {
        bar: {
            pointWidth: 20,
            dataLabels: {
                // y: -2,
                x:2,
                enabled: true,
                format: '{point.y}%',
                style: {
                    fontFamily: 'Roboto',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '11px',
                    textOutline: 'none',
                    lineHeight: '16px',
                    textAlign: 'center',
                    color: '#3D3935'
                }
            }
        }
    },
    legend: {
        enabled: false
    },
    tooltip: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    series: [
        {
            colors: ['#9BC9FF'],
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#F2F3F3',
            name: '',
            // animation: false,
            data: [{y: Math.round(10 / (100) * 100)},
                {y: Math.round(18 / (100) * 100)},
                {y: Math.round(20 / (100) * 100)},
                {y: Math.round(30 / (100) * 100)},
            ]
        }]
}
export default CasualtyAge;
